
export const ROLES = ["Manager", "User", "Administrator"];

export const hasAccess = (userRole, requiredRoles) => {
  return requiredRoles.includes(userRole);
};

export const getUser = async () => {
    return JSON.parse(localStorage.getItem("user"));
}

export const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + '...';
};

export const sumStoreStock = (item) => {
  if (item?.storeStocks) {
    return Object.keys(item.storeStocks)
      .map(key => item.storeStocks[key])
      .reduce((sum, value) => sum + value, 0);
  }
  return 0; // Return 0 if item or item.storeStocks is undefined
};

export function getCartTotal(cartItems) {
  console.log("Cart items", cartItems)
  return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
}

export function getCartDiscount(cartItems) {
  return cartItems.reduce((total, item) => total + (item.discountedPrice * item.quantity), 0);
}

export function getTotalStock(el) {
  if(!el?.storeStocks) return 0;
  return Object.values(el?.storeStocks as { [key: string]: number }).reduce((sum, stock) => sum + stock, 0);
}


export const loadCartFromLocalStorage = () => {
  const cart = localStorage.getItem('cart');
  return cart ? JSON.parse(cart) : [];
};

export const saveCartToLocalStorage = (cart) => {
  localStorage.setItem('cart', JSON.stringify(cart));
};

export function addToCart(item) {
  // Get existing cart from local storage
  let cart = JSON.parse(localStorage.getItem('cart')) || [];

  // Check if the item already exists in the cart
  const index = cart.findIndex(cartItem => cartItem.productId === item.productId);

  if (index !== -1) {
      // If item exists, update the quantity
      cart[index].quantity += 1;
  } else {
      // If item doesn't exist, add it with a quantity of 1
      cart.push({ ...item, quantity: 1 });
  }

  // Save updated cart to local storage
  localStorage.setItem('cart', JSON.stringify(cart));
}

export function getCartItems() {
  const cart = JSON.parse(localStorage.getItem('cart')) || [];
  return cart;
}

export function isInCart(cart, product) {
  const index = cart.findIndex(cartItem => cartItem.productId === product.productId);
            
  if (index !== -1) return true;
  return false;
}

export const getItemCartQuantity = (cart,product) => {
  const foundItem = cart.find(cartItem => cartItem.productId === product.productId);
  console.log({cart, product})
  console.log("found itme",foundItem)

}